<p-dialog #dialog [visible]="shownWelcomeDialog" [style]="{ width: '654px', height: '622px' }"
    [draggable]="false" [modal]="true" [closable]="false" [resizable]="false" [maximizable]="maximize$ | async">
    <p-stepper [value]="1" class="basis-[50rem]" [linear]="true">
        <p-step-list>
            <p-step [value]="1">{{'welcome-dialog-component.stepTitle-1' | transloco}}</p-step>
            <p-step [value]="2">{{'welcome-dialog-component.stepTitle-2' | transloco}}</p-step>
            <p-step [value]="3">{{'welcome-dialog-component.stepTitle-3' | transloco}}</p-step>
        </p-step-list>
        <p-step-panels>
            <p-step-panel [value]="1">
                <ng-template #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <p-scrollpanel [style]="{ width: '100%', height: '380px' }">
                            <div>
                                <p>{{'welcome-dialog-component.step-1.title' | transloco}}</p>
                                <br>
                                <p>{{'welcome-dialog-component.step-1.description-1' | transloco}}</p>
                                <p>{{'welcome-dialog-component.step-1.description-2' | transloco}}</p>
                                <div class="flex align-items-center justify-content-center video-container">
                                    <iframe width="500" height="290" controls
                                        src="https://www.youtube.com/embed/D242hySA69o?si=ZLXBCXvcXett1b5S"
                                        frameborder="0" type="video/mp4" allow="autoplay;"></iframe>
                                </div>
                            </div>
                        </p-scrollpanel>
                        <div class="flex flex-row pt-2">
                            <p-checkbox [binary]="true" size="small" (onChange)="dontShowAgain($event)" [(ngModel)]="checkShowDialog" value="viewOnboarding" inputId="view" />
                            <label for="view" class="ml-2">{{'welcome-dialog-component.step-1.dontShowAgain' | transloco}}</label>
                        </div>
                        <div class="flex flex-row pt-3 align-items-baseline align-content-end justify-content-between">
                            <button class="back-button" type="button"
                                (click)="hideDialog(); navigateToStep('Home Page')">{{'welcome-dialog-component.step-1.backBtn'
                                | transloco}}</button>
                            <button type="button"
                                (click)="activateCallback(2); navigateToStep(2)">{{'welcome-dialog-component.step-1.nextBtn'
                                | transloco}}</button>
                        </div>
                    </div>
                </ng-template>
            </p-step-panel>
            <p-step-panel [value]="2">
                <ng-template *ngIf="dataSource === ''" #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <p-scrollpanel [style]="{ width: '100%', height: '372px' }" class="pb-1">
                            <div class="flex flex-wrap justify-content-start xl:justify-content-center lg:justify-content-center md:justify-content-center  gap-3"
                                style="max-width: 585px; margin-bottom: 157px;">
                                <p-card class="source-card" [style]="{ width: '11rem', overflow: 'hidden' }" (click)="selectDataSource('totalBank')">
                                    <div class="flex flex-row justify-content-start align-items-center">
                                        <img src="/assets/img/platforms/totalBankLogo.png" alt="Logo">
                                        <p>{{'welcome-dialog-component.step-2.cardTotalBank' | transloco}}</p>
                                    </div>
                                </p-card>
                                <p-card class="source-card" [style]="{ width: '11rem', overflow: 'hidden' }" (click)="selectDataSource('openFinance')">
                                    <div class="flex flex-row justify-content-start align-items-center">
                                        <img src="/assets/img/platforms/openFinanceLogo.png" alt="Logo">
                                        <p>{{'welcome-dialog-component.step-2.cardOpenFinance' | transloco}}</p>
                                    </div>
                                </p-card>
                                <p-card class="source-card" [style]="{ width: '11rem', overflow: 'hidden' }"
                                    (click)="selectDataSource('noConection')">
                                    <div class="flex flex-row justify-content-start align-items-center">
                                        <div class="card-img">
                                            <img src="/assets/img/Vector.png" />
                                        </div>
                                        <p>{{'welcome-dialog-component.step-2.cardNoConection' | transloco}}</p>
                                    </div>
                                </p-card>
                                <p-card class="source-card" [style]="{ width: '11rem', overflow: 'hidden' }"
                                    [ngClass]="{ 'disabled-card': true }">
                                    <div class="flex flex-row justify-content-start align-items-center">
                                        <div class="card-img">
                                            <img src="/assets/img/Vector.png" />
                                        </div>
                                        <p>{{'welcome-dialog-component.step-2.cardOfx' | transloco}}</p>
                                    </div>
                                </p-card>
                                <p-card class="source-card" [style]="{ width: '11rem', overflow: 'hidden' }"
                                    [ngClass]="{ 'disabled-card': true }">
                                    <div class="flex flex-row justify-content-start align-items-center">
                                        <div class="card-img">
                                            <img src="/assets/img/Vector.png" />
                                        </div>
                                        <p>{{'welcome-dialog-component.step-2.cardApi' | transloco}}</p>
                                    </div>
                                </p-card>
                            </div>
                        </p-scrollpanel>
                        <div class="flex flex-row pt-6 align-items-baseline align-content-end justify-content-between">
                            <button class="back-button" type="button"
                                (click)="activateCallback(1); navigateToStep(1)">{{'welcome-dialog-component.step-2.backBtn'
                                |transloco}}</button>
                        </div>
                    </div>
                </ng-template>
                <ng-template *ngIf="dataSource === 'noConection'" #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <p-scrollpanel [style]="{ width: '100%', height: '392px' }">
                            <form [formGroup]="form" (ngSubmit)="addCompany()">
                                <div class="flex flex-column xl:flex-row md:flex-row justify-content-center align-content-center">
                                    <div class="col-12 xl:col-4 md:col-4 input-group">
                                        <input formControlName="cnpj" pInputText size="small" type="text"
                                            placeholder="{{'welcome-dialog-component.step-2.identificationInput' | transloco}}"
                                            mask="00.000.000/0000-00" id="cnpj">
                                    </div>
                                    <div class="col-12 xl:col-7 md:col-7 input-group">
                                        <input formControlName="name" pInputText size="small" type="text"
                                            placeholder="{{'welcome-dialog-component.step-2.companyNameInput' |transloco}}">
                                    </div>
                                    <div class="flex justify-content-center">
                                        <p-button class="botao-welcome col-12 sm:col-12 md:col-12 delete-btn" type="button" icon="pi pi-trash"
                                            (click)="deleteCompanie()"></p-button>
                                    </div>
    
                                    <p *ngIf="!message">{{message | transloco}}</p>
                                </div>
                                <div *ngIf="form.invalid" class="flex flex-column col-12 p-error">
                                    <p *ngIf="form.get('cnpj')?.errors?.['required'] && form.get('cnpj')?.touched">
                                        {{'welcome-dialog-component.step-2.requiredCnpj' | transloco}}
                                    </p>
                                    <p *ngIf="form.get('cnpj')?.errors?.['invalidCnpj']">
                                        {{'welcome-dialog-component.step-2.invalidCnpj' | transloco}}
                                    </p>
                                    <p *ngIf="form.get('name')?.errors?.['required'] && form.get('name')?.touched">
                                        {{'welcome-dialog-component.step-2.requiredName' | transloco}}
                                    </p>
                                </div>
                                <div class="flex justify-content-center">
                                    <p-button iconPos="right" class="botao-welcome col-12 sm:col-12 md:col-12 new-btn" icon="pi pi-plus"
                                        label="{{'welcome-dialog-component.step-2.newCompanyBtn' | transloco}}"
                                        type="submit"></p-button>
                                </div>
                            </form>
                            <br>
                            <div class="grid">
                                <p-table class="table-size" [scrollable]="true"
                                    [value]="companies">
                                    <ng-template #header>
                                        <tr>
                                            <th>{{'welcome-dialog-component.step-2.tableHeaderIdentification' |transloco}}
                                            </th>
                                            <th>{{'welcome-dialog-component.step-2.tableHeaderCompanyName' |transloco}}</th>
                                        </tr>
                                    </ng-template>
                                    <ng-template #body let-company>
                                        <tr>
                                            <td>{{ company.documento }}</td>
                                            <td>{{ company.razaoSocial }}</td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </p-scrollpanel>
                        <div class="flex flex-row pt-5 align-items-end align-content-end justify-content-between">
                            <button class="back-button" type="button"
                                (click)="selectDataSource(''); activateCallback(2); navigateToStep(2)">{{'welcome-dialog-component.step-2.noConection.backBtn'
                                |transloco}}</button>
                            <button type="button"
                                (click)="activateCallback(3); navigateToStep(3); postCompanies()">{{'welcome-dialog-component.step-2.noConection.nextBtn'
                                |transloco}}</button>
                        </div>
                    </div>
                </ng-template>
                <ng-template *ngIf="dataSource === 'totalBank'" #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <form [formGroup]="totalBankForm" (ngSubmit)="importTotalBankFirstStep(); activateCallback(3);">
                            <p-scrollpanel [style]="{ width: '100%', height: '408px' }">
                                <div class="col-12 xl:col-12 md:col-12"> 
                                    <p-message severity="warn" icon="pi pi-times-circle" closable>
                                        <div>
                                            {{'welcome-dialog-component.step-2.totalBank.warn.first' | transloco}}    
                                            <ul>
                                                <li>
                                                    {{'welcome-dialog-component.step-2.totalBank.warn.second' | transloco}}
                                                </li>
                                                <li>
                                                    {{'welcome-dialog-component.step-2.totalBank.warn.third' | transloco}}
                                                </li>
                                            </ul>
                                            {{'welcome-dialog-component.step-2.totalBank.warn.fourth' | transloco}}
                                        </div>
                                    </p-message>
                                </div>
                                <p class="pb-3">{{'welcome-dialog-component.step-2.totalBank.title' | transloco}}</p>                                
                                <div class="col-12 xl:col-12 md:col-12">
                                    <input pInputText formControlName="accessAccount" type="text"
                                        placeholder="{{'welcome-dialog-component.step-2.totalBank.accessAccountInput' | transloco}}">
                                    <div *ngIf="form.get('accessAccount')?.invalid && form.get('accessAccount')?.touched">
                                        <p>
                                            {{'registration-component.inputRepeatPasswordError' | transloco}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-12 xl:col-12 md:col-12">
                                    <input pInputText formControlName="username" type="text"
                                        placeholder="{{'welcome-dialog-component.step-2.totalBank.usernameInput' | transloco}}">
                                </div>
                                <div class="col-12 xl:col-12 md:col-12">
                                    <input formControlName="cnpj" pInputText size="small" type="text"
                                    placeholder="{{'create-connection-component.selectConnection.identificationInput' | transloco}}"
                                    mask="00.000.000/0000-00" id="cnpj">
                                </div>                              
                            </p-scrollpanel>
                            <div class="flex flex-row pt-3 align-content-end justify-content-between">
                                <button class="back-button" type="button"
                                    (click)="selectDataSource(''); navigateToStep('Onboarding select data source')">{{'welcome-dialog-component.step-2.totalBank.backBtn'
                                    | transloco}}</button>
                                <button class="button" type="submit" [disabled]="!totalBankForm.valid">{{'welcome-dialog-component.step-2.totalBank.nextBtn' | transloco}}</button>
                            </div>
                        </form>
                    </div>
                </ng-template>
                <ng-template *ngIf="dataSource === 'openFinance'" #content let-activateCallback="activateCallback">
                    <ng-container *ngIf="!iframeUrl; else iframeContent">
                        <div class="openFinance-header">
                            <h3>Open Finance</h3>
                            <p>{{'welcome-dialog-component.step-2.openFinance.subtitle' | transloco}}</p>
                        </div>
                        <div class="openFinance-content">
                            <form [formGroup]="openFinanceForm" (ngSubmit)="showOpenFinanceDialog()">
                                <div class="col-12 xl:col-4 md:col-4 input-group gap-1 mb-1">
                                    <label for="cpf">{{'welcome-dialog-component.step-2.openFinance.cpfInput' | transloco}}</label>
                                    <input formControlName="cpf" id="cpf" pInputText size="small" type="text"
                                        placeholder="000.000.000-00"
                                        mask="000.000.000-00" id="cnpj">
                                </div>
                                <div *ngIf="openFinanceForm.invalid" class="flex flex-column col-12 p-error">
                                    <p *ngIf="openFinanceForm.get('cpf')?.errors?.['required'] && openFinanceForm.get('cpf')?.touched">
                                        {{'welcome-dialog-component.step-2.requiredCpf' | transloco}}
                                    </p>
                                    <p *ngIf="openFinanceForm.get('cpf')?.errors?.['invalidCpf']">
                                        {{'welcome-dialog-component.step-2.invalidCpf' | transloco}}
                                    </p>
                                </div>
                                <div class="input-group ml-2 mb-3 gap-1">
                                    <label for="cnpj">{{'welcome-dialog-component.step-2.openFinance.cnpjInput' | transloco}}</label>
                                    <p-listbox [options]="companies" id="cnpj" formControlName="cnpj" [virtualScroll]="true" 
                                        [checkmark]="true" [virtualScrollItemSize]="40" scrollHeight="142px" class="md:w-56" 
                                    >
                                        <ng-template #item let-company>
                                            <div class="flex flex-column align-content-start mb-2 mt-2">
                                                <span class="font-bold m-0 p-0">{{ company.documento }}</span>
                                                <span class="text-gray-500 m-0 p-0">{{ company.razaoSocial }}</span>
                                            </div>
                                        </ng-template>
                                    </p-listbox>
                                </div>
                                <p-message severity="info" icon="pi pi-info-circle">
                                    <span class="font-bold; font-size: smaller">{{'welcome-dialog-component.step-2.openFinance.message.title' | transloco}}</span><br>
                                    <span style="font-size: smaller;">{{'welcome-dialog-component.step-2.openFinance.message.description' | transloco}}</span>
                                </p-message>
                                <div class="flex flex-row pt-6 align-content-end justify-content-between">
                                    <button class="back-button" type="button"
                                        (click)="selectDataSource(''); navigateToStep('Onboarding select data source')">{{'welcome-dialog-component.step-2.totalBank.backBtn'
                                        | transloco}}</button>
                                    <button class="button" type="submit" [disabled]="openFinanceForm.invalid" 
                                    [style]="{'background-color': openFinanceForm.invalid ? '#808080' : '', 'cursor': openFinanceForm.invalid ? 'not-allowed' : 'default'}">{{'welcome-dialog-component.step-2.totalBank.nextBtn' | transloco}}</button>
                                </div>
                            </form>
                        </div>
                    </ng-container>
                    <ng-template #iframeContent>
                        <p-scrollpanel [style]="{ width: '100%', height: '600px' }">
                            <div class="iframe-container">
                                <p-button class="close-iframe" icon="pi pi-times" (onClick)="selectDataSource('')"></p-button>
                                <iframe [src]="iframeUrl | safe" width="100%" height="600px" frameborder="0"></iframe>
                            </div>
                        </p-scrollpanel>
                    </ng-template>
                </ng-template>            
            </p-step-panel>
            <p-step-panel [value]="3">
                <ng-template *ngIf="dataSource === 'totalBank'" #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <p-scrollpanel class="mb-2" *ngIf="successImport && successImport != null" [style]="{ width: '100%', height: '320px' }">
                            <p-message severity="success" icon="pi pi-times-circle"
                                closable>{{'welcome-dialog-component.step-3.totalBank.success.message' | transloco}}</p-message>
                        </p-scrollpanel>
                        <p-scrollpanel class="mb-2" *ngIf="!successImport && successImport != null" [style]="{ width: '100%', height: '320px' }">
                            <p-message severity="error" icon="pi pi-times-circle"
                                closable>{{'welcome-dialog-component.step-3.totalBank.error.message' | transloco}}</p-message>
                        </p-scrollpanel>
                        <div class="flex flex-row pt-8 mt-1 align-content-end justify-content-between">
                            <button class="back-button" type="button" [disabled]="successImport && successImport != null"
                                (click)="selectDataSource('totalBank'); activateCallback(2); navigateToStep(2)">
                                {{'welcome-dialog-component.step-3.totalBank.error.backBtn' | transloco}}
                            </button>
                            <button class="back-button" type="button" [disabled]="successImport && successImport != null"
                                (click)="checkImportTotalBank();">{{'welcome-dialog-component.step-3.totalBank.checkConsent'
                                | transloco}}
                            </button>                            
                            <button type="button"
                                (click)="hideDialog(); navigateToStep('Home Page')">{{'welcome-dialog-component.step-3.totalBank.error.closeBtn' |
                                transloco}}</button>
                        </div>
                    </div>
                </ng-template>
                <ng-template *ngIf="dataSource === 'noConection' && !successImport" #content let-activateCallback="activateCallback">
                    <div class="flex flex-column">
                        <p-scrollpanel [style]="{ width: '100%', height: '392px' }">
                            <p-message severity="warn" icon="pi pi-times-circle">{{'welcome-dialog-component.step-3.noConection.title' | transloco}}</p-message>
                        </p-scrollpanel>
                        <div class="flex flex-row pt-5 align-items-end align-content-end justify-content-between">
                            <button class="back-button" type="button" (click)="selectDataSource('noConection'); activateCallback(2); navigateToStep(2)">
                                {{'welcome-dialog-component.step-3.noConection.backBtn' | transloco}}
                            </button>
                            <button type="button" (click)="hideDialog(); navigateToStep('Home Page')">
                                {{'welcome-dialog-component.step-3.noConection.nextBtn' | transloco}}
                            </button>
                        </div>
                    </div>
                </ng-template> 
            </p-step-panel>
        </p-step-panels>
    </p-stepper>
</p-dialog>